import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {CurrencyConversionCurrency, CurrencyConversionRateInfo} from '../../dto/currencyConversionCurrency';
import {FormBuilder, FormGroup} from '@angular/forms';
import {FxRateService} from '../services/fx-rate.service';
import {ToastService} from 'angular-toastify';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-fx-rate',
  templateUrl: './fx-rate.component.html',
  styleUrls: ['./fx-rate.component.css']
})
export class FxRateComponent implements OnInit, AfterViewInit, OnDestroy {
  currencies: CurrencyConversionCurrency[] = [];
  cardTypes: string[] = [
    'kingplus',
    'king'
  ];
  form: FormGroup;

  currency: CurrencyConversionCurrency|null;
  cardType = 'kingplus';
  rate: CurrencyConversionRateInfo|null;
  amount = 100;
  targetAmount = 0;
  isLoading = false;

  @ViewChild('currencyContainer') currencyContainerRef!: ElementRef;

  private resizeListener = () => this.updateCurrencyDisplay();


  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeListener);
  }
  displayFullName = false;
  constructor(
    private formBuilder: FormBuilder,
    private fxRateService: FxRateService,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  updateCurrencyDisplay(): void {
    if ( this.currencyContainerRef && this.currencyContainerRef.nativeElement ) {
      const width = this.currencyContainerRef.nativeElement.offsetWidth;
      this.displayFullName = width > 300;
    }

  }

  ngAfterViewInit(): void {
    setTimeout(() => this.updateCurrencyDisplay(), 0); // Defer execution to next tick
    setTimeout(() => this.updateCurrencyDisplay(), 500); // Defer execution to next tick
    setTimeout(() => this.updateCurrencyDisplay(), 1000); // Defer execution to next tick
    window.addEventListener('resize', this.resizeListener);
    // Optional: handle resize dynamically
  }

  initForm() {
    this.currency = this.currencies[0];
    this.form = this.formBuilder.group({
      targetCurrency: this.currency.alphaCd,
      sourceCurrency: 'EUR',
      cardType: 'kingplus',
    });
  }

  ngOnInit(): void {

    let lang = this.route.snapshot.queryParamMap.get('lang');

    if ( !lang) {
lang = 'en';
}

    lang = lang.toLowerCase();
    if ( lang != 'en' && lang != 'de') {
lang = 'en';
}

    this.translate.use(lang);

    this.isLoading = true;
    this.fxRateService.getCurrencies().subscribe(currencies => {
      this.currencies = currencies;

      this.initForm();
      this.isLoading = false;

    });



  }

  getRate() {

    this.isLoading = true;

    const target = this.form.get('targetCurrency').value as string;
    this.currencies.forEach(value => {
      if ( value.alphaCd == target ) {
this.currency = value;
}
    });

    const cardType = this.form.get('cardType').value as string;
    this.cardType = cardType;

    this.fxRateService.getRate('EUR', this.currency.alphaCd, this.cardType, (new Date()).toDateString()).subscribe(rate => {
      this.rate = rate;
      this.isLoading = false;

      }, err => {
      this.toastService.error(err.error.message || err.error || err.message);
      this.isLoading = false;
    });
  }

  clearRate() {
    this.rate = null;
  }
}
